export default __webpack_public_path__ + "static/media/coffee_Unlocked.b252c4fb.png";